export const Page: React.FC<{children: JSX.Element | JSX.Element[]}> = ({children}) => <div className={'mx-auto'}>{children}</div>;